// eslint-disable-next-line
export function ServerException(message) {
  this.name = 'ServerException';
  this.message = message;
}



// WEBPACK FOOTER //
// ./src/util/exceptions.js